import React from 'react';
import { FileDrop } from 'react-file-drop'
import './editor.css'
import Editor from './Editor'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLightbulb, faMoon } from '@fortawesome/free-solid-svg-icons'
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";


class VideoEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isUpload: true,
            videoUrl: "",
            isDarkMode: false,
            // isDarkMode: true,
            clipVideoURL: "",
            mataDatawithURL:[]
        }
 
    }
   

    componentDidMount = () => {
        
        this.toggleThemes()
        document.addEventListener('drop', function(e) {
            e.preventDefault();
            e.stopPropagation();
          });

      var clipVideoURL=this.props.location.state.clippingURL;
      this.setState({ clipVideoURL });
      
    //   console.log("clipVideoURL11",clipVideoURL);
    }

    render_uploader = () => {
        return(
            <div className={"wrapper"}>
                <input
                    onChange={(e) => this.upload_file(e.target.files)}
                    type="file"
                    className="hidden"
                    id="up_file"
                />
                <FileDrop
                    onDrop={(e) => this.upload_file(e)}
                    onTargetClick={() => document.getElementById("up_file").click()}
                >
                    Click or drop your video here to edit!
                </FileDrop>
            </div>
        )
    }

    saveVideo = (metadata) => {

        console.log(metadata)
        // alert("Please check your console to see all the metadata. This can be used for video post-processing.")
    //   var mataDatawithURL=metadata.trim_times;
    //   this.setState({ mataDatawithURL });
     
      var mataDatawithURL =[]
      var obj = {}
      obj["VideoURL"] = this.state.clipVideoURL;
      obj["metadata"] = metadata.trim_times;

      mataDatawithURL.push(obj)
      this.setState({ mataDatawithURL });
      console.log("mataDatawithURL",mataDatawithURL);

    }

    render_editor = () => {
        return(
            // Props:
            // videoUrl --> URL of uploaded video
            // saveVideo(<metadata of edited video>) --> gives the cut times and if video is muted or not
            <Editor videoUrl={this.state.clipVideoURL} saveVideo={this.saveVideo}/>
        )
    }

    toggleThemes = () =>{
        if(this.state.isDarkMode){
            document.body.style.backgroundColor = "#1f242a";
            document.body.style.color = "#fff";
        }
        else{
            document.body.style.backgroundColor = "#fff";
            document.body.style.color = "#1f242a";
        }
        this.setState({isDarkMode: !this.state.isDarkMode})
    }

    // upload_file = (fileInput) => {
	// 	let fileUrl = window.URL.createObjectURL(fileInput[0]);
    //     let filename = fileInput.name;
    //     this.setState({
    //         isUpload: false,
    //         videoUrl: "https://devapi.contendzone.com/ContendZONE/api/file/downloadFile/1640017064792.mp4"
    //     })
    // }

    render = () => {
        return(
            <div>
                <div>
                <Link
              to={{
                pathname: "/pdftron",
                state: { annotVidURL: this.state.clipVideoURL },
               }}
            >
              <Button className="Clippinng" style={{ backgroundColor: '#747578', float: "right" }}>
                Back
              </Button>
            </Link>
                </div>
                {this.render_editor()}
                <div className={"theme_toggler"} onClick={this.toggleThemes}>{this.state.isDarkMode? (<i className="toggle" aria-hidden="true"><FontAwesomeIcon icon={faLightbulb} /></i>) : <i className="toggle"><FontAwesomeIcon icon={faMoon} /></i>}</div>
            </div>
        )
    }
}

export default VideoEditor